import { ConfirmSetForm } from '../confirm-set-form/confirm-set-form';

export const ChangeTypeSetForm = (props) => {
  const { close, action, working, title } = props;
  // console.log('🚀 ~ ChangeTypeSetForm ~ props:', props);

  // const title = 'Изменить тип СО выбранных записей?';

  const params = {
    title: title + '?',
    close,
    action,
    working,
  };

  return <ConfirmSetForm {...params} />;
};
